import React from "react";
import "./carouselWrap.scss";
const CarouselWrap = ({ varient, children }) => {
  return (
    <div className={varient ? `carousel_wrap ${varient}` : "carousel_wrap"}>
      <div className="carousel_in">{children}</div>
    </div>
  );
};

export default CarouselWrap;
